var _path, _circle, _circle2, _circle3, _circle4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLineGraphIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 26,
    viewBox: "0 0 58 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 25L16.5 10L41 19L57 1",
    stroke: "#1B79DA",
    strokeWidth: 0.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 1.5,
    r: 1.35,
    fill: "white",
    stroke: "#1B79DA",
    strokeWidth: 0.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 18.5,
    r: 1.35,
    fill: "white",
    stroke: "#1B79DA",
    strokeWidth: 0.3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 10.5,
    r: 1.35,
    fill: "white",
    stroke: "#1B79DA",
    strokeWidth: 0.3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 24.5,
    r: 1.35,
    fill: "white",
    stroke: "#1B79DA",
    strokeWidth: 0.3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineGraphIcon);
export default __webpack_public_path__ + "static/media/LineGraphIcon.a1657059a5b3363de3bfb013c5033a80.svg";
export { ForwardRef as ReactComponent };